import useSeo from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import QuickEntries from "./components/QuickEntries";
import HotMovies from "./components/HotMovies";
import NewsSection from "./components/NewsSection";
import TopicSection from "./components/TopicSection";
import IntroSection from "./components/IntroSection";

export default function Home() {
  useSeo({
    title: "我的老婆姐姐 - 影视剧资讯与剧情介绍",
    description:
      "我的老婆姐姐提供全面的影视剧资讯、剧情介绍和演员信息，覆盖最新电视剧和电影内容，满足影视爱好者的观看和了解需求。",
    keywords: "我的老婆姐姐,影视剧,剧情介绍,演员信息,影视资讯,电视剧,电影",
  });

  return (
    <>
      <HeroCarousel />
      <QuickEntries />
      <HotMovies />
      <NewsSection />
      <TopicSection />
      <IntroSection />
    </>
  );
}